/**
 * Featured In marquee
 * - Wait for logo images before measuring (fixes mobile jump + initial speed burst)
 * - Animate by exact group pixel width (not -50%) for a seamless loop
 */
(function () {
  function waitForImages(container) {
    var imgs = Array.prototype.slice.call(container.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();

    return Promise.all(
      imgs.map(function (img) {
        var ready = Promise.resolve();
        if (!img.complete || !img.naturalWidth) {
          ready = new Promise(function (resolve) {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        }
        return ready.then(function () {
          if (typeof img.decode === 'function') {
            return img.decode().catch(function () {});
          }
        });
      })
    );
  }

  function prepare(root) {
    if (!root) return;
    var marquee = root.querySelector('[data-fi-marquee]');
    var track = root.querySelector('[data-fi-track]');
    if (!marquee || !track) return;

    // Avoid overlapping inits
    var token = String(Date.now()) + Math.random();
    root.setAttribute('data-fi-token', token);

    // Reset clones / animation
    Array.prototype.slice.call(track.querySelectorAll('[data-fi-group]')).forEach(function (el, i) {
      if (i > 0) el.parentNode.removeChild(el);
    });
    track.classList.remove('is-ready');
    track.style.removeProperty('--fi-duration');
    track.style.removeProperty('--fi-shift');
    track.style.removeProperty('animation-duration');

    var source = track.querySelector('[data-fi-group]');
    if (!source) return;

    waitForImages(source).then(function () {
      if (root.getAttribute('data-fi-token') !== token) return;

      // Force layout after images paint
      window.requestAnimationFrame(function () {
        if (root.getAttribute('data-fi-token') !== token) return;

        var groupWidth = Math.round(source.getBoundingClientRect().width);
        if (!groupWidth) {
          // Retry shortly if still collapsed
          window.setTimeout(function () {
            if (root.getAttribute('data-fi-token') === token) prepare(root);
          }, 100);
          return;
        }

        function cloneGroup() {
          var clone = source.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach(function (node) {
            node.removeAttribute('id');
          });
          track.appendChild(clone);
        }

        // Always at least 2 identical groups; fill enough to cover viewport + 1 group
        while (track.querySelectorAll('[data-fi-group]').length < 2) {
          cloneGroup();
        }
        var guard = 0;
        while (track.scrollWidth < marquee.offsetWidth + groupWidth && guard < 16) {
          cloneGroup();
          guard += 1;
        }

        // Re-measure after clones (should match source)
        groupWidth = Math.round(source.getBoundingClientRect().width);

        var pxPerSec = parseFloat(root.getAttribute('data-fi-px-per-sec'), 10);
        if (!pxPerSec || pxPerSec < 1) pxPerSec = 50;

        // Duration for moving exactly one group — stable across editor/live/mobile
        var duration = groupWidth / pxPerSec;
        // Floor so a tiny mis-measure never creates a tiny duration / speed burst
        if (duration < 8) duration = 8;

        track.style.setProperty('--fi-shift', groupWidth + 'px');
        track.style.setProperty('--fi-duration', duration.toFixed(2) + 's');
        track.style.animationDuration = duration.toFixed(2) + 's';

        window.requestAnimationFrame(function () {
          if (root.getAttribute('data-fi-token') !== token) return;
          track.classList.add('is-ready');
        });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-featured-in]').forEach(prepare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  window.addEventListener('load', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll();
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      initAll();
    }, 200);
  });
})();
